import { MoreOutlined } from "@ant-design/icons";
import { Button, Dropdown } from "antd";
import useDropdownItems from "../hooks/useDropDownItems";
import "./DropdownOptionsActions.scss";

export type DropdownOptionsActionsProps = {
  itemId: number;
  iAmTheAssignedPilote: boolean;
  onDelete: (id: number) => void;
  onModify: (id: number) => void;
  goToDetails: (id: number) => void;
};

const DropdownOptionsActions = (props: DropdownOptionsActionsProps) => {
  const items = useDropdownItems(props);

  return (
    <Dropdown menu={{ items }} trigger={["click"]}>
      <Button
        type="link"
        icon={<MoreOutlined className="icon-more" />}
        onClick={(e) => e.stopPropagation()}
      />
    </Dropdown>
  );
};

export default DropdownOptionsActions;
